export default __webpack_public_path__ + "static/AppBeers3-debad3d083745bacdd7cfbec5782753c.png";